<template>
  <NotFoundError>
    <template #title>Parapheur non trouvé</template>

    <template #hat>
      <p class="text-h1">Le parapheur auquel vous essayez d'accéder n'existe pas ou a été supprimé.</p>
    </template>

    <template #subtitle>
      <p></p>
    </template>

    <template #help>
      <p></p>
    </template>
  </NotFoundError>
</template>

<script setup lang="ts">
import { NotFoundError } from "@pasta/box-v2";
</script>
